import type { FaireProductEntity } from "../../entity_types/product";

export const p_9avk7724w3: FaireProductEntity = {
  token: "p_9avk7724w3",
  type: "product",
  name: "Sugar Mama Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1dfa8341cc4ec2447f6999119599d822fda499ef04abd43581099526d09193eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c7097f426acdab1f09627042522ce9f8a4debcac03af5bc5015239a204060f4.jpeg",
    "https://cdn.faire.com/fastly/eab4e9a03f0c618e365b4375ad9c8a8becda0b737ad1091ddb0e35efdb362293.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3b6a1839e3dc3f8ad79266563fc6a4838c77e71873948b58405891f4c8947431.jpeg",
    "https://cdn.faire.com/fastly/b8d5f756fded112aca33bfff3cccaf29ecb751ebed0ffa915e47570f140b1e89.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nDoesn't matter if it's money or candy (or some other sweet thang)... if you make it rain, you're Sugar Mama, and you deserve some socks that say as much.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:30.110Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
